import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, vModelCheckbox as _vModelCheckbox, unref as _unref, createBlock as _createBlock, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "s6_mobile" }
const _hoisted_2 = {
  key: 0,
  class: "form-field-floating reactive active my-4"
}
const _hoisted_3 = {
  for: "file-upload2",
  class: "custom-upload my-5"
}
const _hoisted_4 = { class: "custom-upload-st2" }
const _hoisted_5 = {
  key: 1,
  style: {"display":"flex","justify-content":"center"}
}
const _hoisted_6 = { class: "secondary-font gap-4 mt-0 mb-5 px-6" }
const _hoisted_7 = { class: "table separator skin1 sm selection" }
const _hoisted_8 = {
  class: "btn-circle",
  for: "check_all"
}
const _hoisted_9 = ["checked"]
const _hoisted_10 = { class: "selection-item" }
const _hoisted_11 = ["for"]
const _hoisted_12 = ["id", "value", "disabled"]
const _hoisted_13 = { class: "font-black" }
const _hoisted_14 = {
  key: 0,
  style: {"height":"16px","margin-left":"5px","filter":"invert(19%) sepia(93%) saturate(4156%) hue-rotate(355deg) brightness(101%) contrast(105%)"},
  src: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAABaCAYAAAA4qEECAAAACXBIWXMAAAsTAAALEwEAmpwYAAAEB0lEQVR4nO2dTahWRRjHf5ofmF+YYooomopIghC4EAwiaeEiF6KgkpsSEj9QFLJNmYIaGNUiDApyVaKibkw3akSWJHEVhEoqlURDUbPMrPQ2MjAnRDrjfc/MnJk55/nBf3PvZZ7n/+d97znvfWbOBUEQBEEQBEEQBMGJfsBS4Bhw1egL4EXzPcEDw4HjgCrRN8DI2E3mTh+gyxLy/WE/ErvZnFnZg5AL6Z8VKvCY+V3c06CvAyOqFGo773cQcqHtsZvOjSeBOxWCvgtMj918TnxWIeRC+ravV2wDObDAIeRC82ObSJ0BwDkPQf8MPBrbTMq87iHkQq/FNpMqY4A/PAb9JzAutqkU+cRjyIU+jm0qNWYC/wYIWq/5dGxzqdAbOBEg5EJdpkbrWRow5EIv0XIGA5dqCPoyMJQW81YNIRfaRkuZBPxVY9B/A1NoIZ/WGHKhA7SM5yKEXGgOLaEv8H3EoH8A+tMC1kUMudBaGs5I4NcEgv4NGEWD+TCBkAt9QEN5CuiuGMpyYFiJlldcs9v01Dg+d3j1vWxZd5nDul82bey1yPFtvtqy9hrHtRfSoPHUeccw1lvWf9Vx7QvAQBrARscgtDZY1n/Dw/p6jawZC9zyEMQWS42tnsZe48mY3R5CUMDblhrveKqxi0yZ5XE8td3z1rEyPUNm9DZbaX0F8JGl1g6PdU7ltv3X5d5W/Y/0hLyMnZ5r2e7Zk0J/Wrvi2fw+S739nmtdM6cMkuddz8YVcNBS71CAevoCmzRTgX8CGD8aaOdpmfSW4WkkTIhXlwK+stS0HSRy0WESZW4gw8psginjZMC6z5MY+qzfmYCGv7XU/i5g3R9TG3utD2hWAWcttX3sp7bpFRLhceBGYLOXLPV/CVz7d2A0CeDzk5myHG0ro44ZpPYYlRkO4ynVgfQt45slCnE7+aC6jdco9DInoFRLdDzW2GtJAuZVzXqh7pAHARcTMK5qlr7wDqkz6M0JmFaRpL3XwhPA7QQMq0jS238n1xH03kgGb5nR2Eaj3Z7mkb7/bOuFZyMZO2/eSQ8y0ZySjdHT7JBPgzkdydQiS1+LI/V02mTinRWRDClggqWv0RH70plEfRqMb4239DYqYl/XTDbeeC+iGfWQ/XGu+/pcpbPxwrSKT4PxfTGcWHKyK9bF0PvY63BkI+q+bVt7gE1Ge8zXVAI64hryvARMqEyks6qEHuH8lIABlYnOVh171XEYXjVMOrOOOZZA4yoz6aMaHXM9gcZVZtL31R1zM4HGVWbS5xc75usEGlcZjrs6ZlUCjavMVOmJv/0Db7dSDdNJl6ez62fRSdj0KGSdlRP9zFtC//6RCyT/6abZ5aqzkf8zIAiCIAiCIAiCIAgCbeIeKS6tsZ2f6DkAAAAASUVORK5CYII=",
  alt: "error--v1"
}
const _hoisted_15 = {
  key: 1,
  style: {"height":"16px","margin-left":"5px","filter":"invert(19%) sepia(93%) saturate(4156%) hue-rotate(130deg) brightness(101%) contrast(105%)"},
  src: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAABTklEQVR4nK2VPUoEQRCFv8jYwEBdxauIkeK699BZEwMDb2EkiicwmsC/SwhG/oGZqaCrBrJKS0nZ9EpP/808eDBM17zqqa56DWEsAkPgArgF3pXyfA5UwAIF6AGHwBgwEX4DJ8BSqvgAGCUIm3+UbzZi4tu6o1xx4/yNlNSLNeCrhbhxkgx8NS8pi2ngKzDnJjjuUNwopUlsK7YpzSdw7Xk/1sr8Hkqp+AewrBu99KxvoQPTVrwHPHliTmXxoVB8RcVngZuGuDsC3XMFTAN7kZ2HNjiKJZhSod0CcZvgPhBQO0l2MsWNmmL0kGsnSY64PeQqIbDWJDniwk3Uz1Ns+RF4zhC3gyY4KpwFE+CB60XzHZvdi87HBFY7tOt+050w7ODCqYigr35eUpb1mPgfZoD9xO6SGPH+iQsmFdJm0stnamhvSnmWIZI124o+/AB50KFiqZyaQQAAAABJRU5ErkJggg==",
  alt: "external-verified-check-circle-for-approved-valid-content-basic-bold-tal-revivo"
}
const _hoisted_16 = { class: "font-bold" }
const _hoisted_17 = { class: "font-bold" }
const _hoisted_18 = { class: "font-bold" }
const _hoisted_19 = { class: "text-sm text-grey-500" }
const _hoisted_20 = { class: "flex-right" }
const _hoisted_21 = ["onClick"]
const _hoisted_22 = { class: "s14_mobile px-3" }
const _hoisted_23 = { class: "s6_mobile px-4" }
const _hoisted_24 = {
  key: 3,
  class: "alert alert-danger mb-4"
}

import { computed, reactive, ref } from 'vue';
    import OnboardingGroupeItemDetailsModal from './OnboardingGroupeItemDetailsModal.vue';
    import { formatAmount } from '@/utils';
        import axios from 'axios';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'OnboardingGroupeComponent',
  props: {
        collectivite: { type: Object, default: null },
        isWidgetMode: { type: Boolean, default: true }
    },
  emits: ['completed'],
  setup(__props, { emit: __emit }) {

    // @ts-expect-error raison: lib externe mal typée
    const props = __props
    const emit = __emit;
    const loading = ref(false);
    const errorMessage = ref('');
    const importFile = ref<File | null>(null);
    const importDatas = ref([] as Array<any>);
    const itemDetailsModalRef = ref<InstanceType<typeof OnboardingGroupeItemDetailsModal> | null>(null);
    const queryParams = reactive({
        pageNumber: 1
    });
    const pagination = reactive({
        total: 0,
        per_page: 5,
        last_page: 1
    });
    const paginatedImportDatas = ref([] as Array<any>);
    const selectedItems = ref([] as any[]);
    const areAllItemsSelected = computed(() => {
        return paginatedImportDatas.value.filter(i => !i.has_errors).length == selectedItems.value.length;
    });
    const collectivite = ref(props.collectivite);
    const sendKycEmail = ref(true);
    const loadingDownloadCsv = ref(false);

    async function downloadCsv() {
        try {
            loadingDownloadCsv.value = true;
            const response = await axios.get("/backoffice/onboarding/download_excel_template", { responseType: "blob" });
            const blob = new Blob([response.data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
            const url = window.URL.createObjectURL(blob);

            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", "onboarding_groupe_template.xlsx");
            document.body.appendChild(link);
            link.click();
            link.remove();
        } catch (error) {
            console.error("Erreur de téléchargement :", error);
        } finally {
            loadingDownloadCsv.value = false;
        }
    }
    async function onCsvImportFileLoaded(event: Event) {
        const input = event.target as HTMLInputElement;
        if (input.files && input.files.length > 0) {

            selectedItems.value = [];
            importDatas.value = [];
            paginatedImportDatas.value = [];
            queryParams.pageNumber = 1;
            pagination.total = 0;

            const file = input.files[0];
            await doImportCsvImportFileAction(file);

            pagination.total = importDatas.value.length;
            pagination.last_page = Math.ceil(pagination.total / pagination.per_page);
            onPaginate(queryParams.pageNumber);
            input.value = '';
        }
    }
    async function doImportCsvImportFileAction(csvFile: File) {
        try {
            loading.value = true;
            errorMessage.value = '';
            importFile.value = null;
            importDatas.value = [];

            const formToUpload = new FormData();
            formToUpload.append("import_file", csvFile);
            const response = await axios.post(`/backoffice/onboarding/prepare_import_file`, formToUpload);
            importDatas.value = response.data;
            importFile.value = csvFile;
            selectedItems.value = importDatas.value.filter(i => !i.has_errors).map(i => i.data.guid);

        } catch (error: any) {
            errorMessage.value = error;
        } finally {
            loading.value = false;
        }
    }

    function showItemDetailsModal(dataRow: any) {
        if (itemDetailsModalRef.value) {
            itemDetailsModalRef.value.open(dataRow);
        }
    }

    function onPaginate(page: number) {
        queryParams.pageNumber = page;
        const start = (page - 1) * pagination.per_page;
        paginatedImportDatas.value =  importDatas.value.slice(start, start + pagination.per_page);
    }

    function handleCheckAll(_event: any) {
        const checked = _event.target.checked;
        if (checked) {
            selectedItems.value = paginatedImportDatas.value.filter(i => !i.has_errors).map(i => i.data.guid);
        } else {
            selectedItems.value = [];
        }
    }

    async function doImportSelectionAction() {
        const selectionDatas = importDatas.value.filter(i => selectedItems.value.includes(i.data.guid)).map(i => i.data);
        if (selectionDatas.length == 0) { return; }

        try {
            loading.value = true;
            errorMessage.value = '';
            const response = await axios.post('/backoffice/onboarding/import_file_datas', { import_datas: selectionDatas, send_kyc_email: sendKycEmail.value, collectivite_id: collectivite.value.id });
            emit('completed', response.data);
        } catch(error: any) {
            errorMessage.value = error;
        } finally {
            loading.value = false;
        }
    }

    

return (_ctx: any,_cache: any) => {
  const _component_custom_button = _resolveComponent("custom-button")!
  const _component_custom_pagination = _resolveComponent("custom-pagination")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", {
      class: _normalizeClass(["px-8 py-7 s20", {'widget': __props.isWidgetMode}])
    }, [
      _cache[20] || (_cache[20] = _createElementVNode("div", { class: "s14_mobile" }, [
        _createElementVNode("h2", { class: "secondary-font gap-4 mt-2 mb-2" }, " Onboarding groupé - Création de compte en masse "),
        _createElementVNode("p", { class: "mb-0" }, "Format de fichier supporté: CSV. Taille max: 50MB.")
      ], -1)),
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_custom_button, {
          loading: loadingDownloadCsv.value,
          type: "button",
          classesList: 'btn black stroke w-100 flex-center my-2',
          onClick: downloadCsv
        }, {
          default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
            _createElementVNode("img", {
              src: "/icons/icon-telecharger.svg",
              class: "btn-icon icon-neutral",
              alt: ""
            }, null, -1),
            _createElementVNode("span", null, "Modèle de fichier EXCEL", -1)
          ]))]),
          _: 1
        }, 8, ["loading"])
      ]),
      _cache[21] || (_cache[21] = _createElementVNode("div", { class: "clear-both h-0" }, null, -1)),
      (collectivite.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _withDirectives(_createElementVNode("input", {
              type: "text",
              class: "form-input",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((collectivite.value.nom) = $event)),
              name: "collectivite_nom",
              id: "collectivite_nom",
              placeholder: "",
              readonly: true
            }, null, 512), [
              [_vModelText, collectivite.value.nom]
            ]),
            _cache[4] || (_cache[4] = _createElementVNode("label", { for: "collectivite_nom" }, [
              _createTextVNode("Collectivité "),
              _createElementVNode("b", { class: "color-danger" }, "*")
            ], -1))
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("label", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("input", {
            id: "file-upload2",
            name: "file-upload",
            type: "file",
            accept: ".xlsx",
            onChange: onCsvImportFileLoaded
          }, null, 32),
          _cache[5] || (_cache[5] = _createStaticVNode("<div class=\"s4 custom-upload-img\">.XLSX</div><div class=\"s12\"><span id=\"file-upload-title\" class=\"custom-upload-text\">Charger le fichier EXCEL</span> <b class=\"color-danger\">*</b><br><span id=\"file-upload-title\" class=\"custom-upload-text\">Uploader le doc</span></div><div class=\"s4 right\"><img src=\"/icons/icon-upload.svg\" class=\"custom-upload-icon\"></div>", 3))
        ])
      ]),
      _cache[22] || (_cache[22] = _createElementVNode("div", { class: "clear-both h-10" }, null, -1)),
      (loading.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [...(_cache[6] || (_cache[6] = [
            _createElementVNode("div", { class: "loader dark" }, null, -1)
          ]))]))
        : _createCommentVNode("", true),
      (!loading.value && importFile.value)
        ? (_openBlock(), _createElementBlock("div", {
            key: 2,
            class: _normalizeClass(["py-6 s20", {'widget': __props.isWidgetMode}])
          }, [
            _createElementVNode("h2", _hoisted_6, _toDisplayString(importFile.value.name), 1),
            _createElementVNode("table", _hoisted_7, [
              _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("th", null, [
                    _createElementVNode("label", _hoisted_8, [
                      _createElementVNode("input", {
                        type: "checkbox",
                        id: "check_all",
                        checked: areAllItemsSelected.value,
                        onChange: handleCheckAll
                      }, null, 40, _hoisted_9)
                    ])
                  ]),
                  _cache[7] || (_cache[7] = _createElementVNode("th", null, null, -1)),
                  _cache[8] || (_cache[8] = _createElementVNode("th", null, [
                    _createElementVNode("img", {
                      src: "/icons/icon-filter-up.svg",
                      class: "size-xxs mt--1",
                      alt: ""
                    }),
                    _createTextVNode(" Nom ")
                  ], -1)),
                  _cache[9] || (_cache[9] = _createElementVNode("th", null, [
                    _createElementVNode("img", {
                      src: "/icons/icon-filter-down.svg",
                      class: "size-xxs mt--1",
                      alt: ""
                    }),
                    _createTextVNode(" Prénoms ")
                  ], -1)),
                  _cache[10] || (_cache[10] = _createElementVNode("th", null, [
                    _createElementVNode("img", {
                      src: "/icons/icon-filter-none.svg",
                      class: "size-xxs mt--1",
                      alt: ""
                    }),
                    _createTextVNode(" Salaire brut ")
                  ], -1)),
                  _cache[11] || (_cache[11] = _createElementVNode("th", null, [
                    _createElementVNode("img", {
                      src: "/icons/icon-filter-up.svg",
                      class: "size-xxs mt--1",
                      alt: ""
                    }),
                    _createTextVNode(" Quotité cessible ")
                  ], -1)),
                  _cache[12] || (_cache[12] = _createElementVNode("th", null, [
                    _createElementVNode("img", {
                      src: "/icons/icon-filter-up.svg",
                      class: "size-xxs mt--1",
                      alt: ""
                    }),
                    _createTextVNode(" Contact ")
                  ], -1)),
                  _cache[13] || (_cache[13] = _createElementVNode("th", { class: "flex-right" }, null, -1))
                ])
              ]),
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(paginatedImportDatas.value, (dataRow, index) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: 'row_' + index,
                    class: "text-grey-700 over-effect"
                  }, [
                    _createElementVNode("td", _hoisted_10, [
                      _createElementVNode("label", {
                        class: "btn-circle",
                        for: 'item_check_' + index
                      }, [
                        _withDirectives(_createElementVNode("input", {
                          type: "checkbox",
                          name: "selectedItems[]",
                          id: 'item_check_' + index,
                          value: dataRow.data.guid,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((selectedItems).value = $event)),
                          disabled: dataRow.has_errors
                        }, null, 8, _hoisted_12), [
                          [_vModelCheckbox, selectedItems.value]
                        ])
                      ], 8, _hoisted_11)
                    ]),
                    _createElementVNode("td", _hoisted_13, [
                      _cache[14] || (_cache[14] = _createElementVNode("img", {
                        src: "/icons/icon-data.svg",
                        class: "size-medium"
                      }, null, -1)),
                      (dataRow.has_errors)
                        ? (_openBlock(), _createElementBlock("img", _hoisted_14))
                        : _createCommentVNode("", true),
                      (!dataRow.has_errors)
                        ? (_openBlock(), _createElementBlock("img", _hoisted_15))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("td", _hoisted_16, _toDisplayString(dataRow.data.nom), 1),
                    _createElementVNode("td", null, _toDisplayString(dataRow.data.prenom), 1),
                    _createElementVNode("td", _hoisted_17, _toDisplayString(_unref(formatAmount)(dataRow.data.salaire)) + " F CFA", 1),
                    _createElementVNode("td", _hoisted_18, [
                      _createTextVNode(_toDisplayString(_unref(formatAmount)(dataRow.data.quotite_cessible_montant)) + " ", 1),
                      _cache[15] || (_cache[15] = _createElementVNode("br", null, null, -1)),
                      _createTextVNode(" (" + _toDisplayString(dataRow.data.quotite_cessible_pourcent) + "%)", 1)
                    ]),
                    _createElementVNode("td", _hoisted_19, [
                      _createTextVNode(_toDisplayString(dataRow.data.telephone) + " ", 1),
                      _cache[16] || (_cache[16] = _createElementVNode("br", null, null, -1)),
                      _createTextVNode(" " + _toDisplayString(dataRow.data.email), 1)
                    ]),
                    _createElementVNode("td", _hoisted_20, [
                      _createElementVNode("button", {
                        class: "btn white2 collapse-open-table",
                        onClick: ($event: any) => (showItemDetailsModal(dataRow))
                      }, [...(_cache[17] || (_cache[17] = [
                        _createElementVNode("img", {
                          src: "/icons/icon-list.svg",
                          class: "btn-icon",
                          alt: ""
                        }, null, -1),
                        _createElementVNode("span", null, "Plus", -1)
                      ]))], 8, _hoisted_21)
                    ])
                  ]))
                }), 128))
              ])
            ]),
            _cache[19] || (_cache[19] = _createElementVNode("div", { class: "clear-both h-15" }, null, -1)),
            _createElementVNode("div", _hoisted_22, [
              _createVNode(_component_custom_pagination, {
                modelValue: queryParams.pageNumber,
                "onUpdate:modelValue": [
                  _cache[2] || (_cache[2] = ($event: any) => ((queryParams.pageNumber) = $event)),
                  onPaginate
                ],
                total: pagination.total,
                "per-page": pagination.per_page,
                last_page: pagination.last_page
              }, null, 8, ["modelValue", "total", "per-page", "last_page"])
            ]),
            _createElementVNode("div", _hoisted_23, [
              (selectedItems.value.length > 0)
                ? (_openBlock(), _createBlock(_component_custom_button, {
                    key: 0,
                    type: "button",
                    classesList: 'btn lg w-100 flex-center my-2',
                    disabled: selectedItems.value.length == 0,
                    onClick: doImportSelectionAction
                  }, {
                    default: _withCtx(() => [
                      _cache[18] || (_cache[18] = _createElementVNode("img", {
                        src: "/icons/icon-telecharger.svg",
                        class: "btn-icon",
                        alt: ""
                      }, null, -1)),
                      _createElementVNode("span", null, "Importer (" + _toDisplayString(selectedItems.value.length) + ")", 1)
                    ]),
                    _: 1
                  }, 8, ["disabled"]))
                : _createCommentVNode("", true)
            ])
          ], 2))
        : _createCommentVNode("", true),
      (errorMessage.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_24, _toDisplayString(errorMessage.value), 1))
        : _createCommentVNode("", true)
    ], 2),
    _createVNode(OnboardingGroupeItemDetailsModal, {
      ref_key: "itemDetailsModalRef",
      ref: itemDetailsModalRef
    }, null, 512)
  ]))
}
}

})